import styled from 'styled-components';
import {CSS_CONSTANTS} from '../../../../css_variables';

export const ButtonWrapper = styled.div`
	display: flex;
	margin-top: 12px;
	flex-direction: row;
`;

export const AddTenantButtonWrapper = styled.div``;

export const HelpButtonWrapper = styled.div`
	margin-left: 8px;
`;

/* The connect half of the page - organisations and Add - in a box of its own, so the two halves
   read as two distinct things rather than one run-on list. */
export const ConnectSection = styled.div`
	padding: 20px;
	border: 1px solid ${CSS_CONSTANTS.color_light_grey};
	border-radius: 4px;
`;
